// extracted by mini-css-extract-plugin
export var divider = "_3d-0";
export var dividerText = "_3d-1";